"use client";

import { useAccount } from "wagmi";
import ProfileConnect from "../custom/ProfileConnect";
import { useGlobalModal } from "../modals/modal-provider";
import ConnectWalletModal from "../modals/connect-wallet";
import { BaseButton } from "../share/button";

const modalId = "modalId-connect";

export function ConnectWallet() {
  const { address, isConnected } = useAccount();
  const { openModal, closeModal } = useGlobalModal();

  if (isConnected && address) {
    return <ProfileConnect onCancelMenu={() => {}} />;
  }

  const handleShowConnect = () => {
    openModal({
      title: "Kết nối ví",
      body: (
        <ConnectWalletModal
          onCancel={() => {
            closeModal(modalId);
          }}
        />
      ),
      classNameContent: "!max-w-[900px]",
      modalId: modalId,
    });
  };

  return (
    <>
      <BaseButton
        outline
        onClick={handleShowConnect}
        className="flex items-center gap-2 h-12"
      >
        Kết nối ví
      </BaseButton>
    </>
  );
}
